import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Header from "./Header";
import Footer from "./Footer";
import Home from "./Home";
import About from "./About";
import Services from "./Services";
import Career from "./Career";
import Contact from "./Contact";
import Wallmuralchennai from "./Wallmuralchennai";
import Wallsculptureschennai from "./Wallsculptureschennai";
import Largecanvaschennai from "./Largecanvaschennai";
import Homedecorschennai from "./Homedecorschennai";
import Fiberglasschennai from "./Fiberglasschennai";
import Artisticcontainerschennai from "./Artisticcontainerschennai";
import Facadeschennai from "./Facadeschennai";
import Weddingartchennai from "./Weddingartchennai";
import Blog1 from "./Blog1";
import Blog2 from "./Blog2";
import Blog3 from "./Blog3";
import Blog4 from "./Blog4";

const globalStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400;1,700&family=Space+Grotesk:wght@300;400;500;600&family=Caveat:wght@500;700&display=swap');
  *, *::before, *::after { 
    box-sizing: border-box; 
    margin: 0; 
    padding: 0; 
  }
  :root {
    --ink:       #1a0a2e;
    --canvas:    #fdf6ec;
    --gold:      #e8a020;
    --fuchsia:   #d6246e;
    --teal:      #0ab5a8;
    --lavender:  #7c5cbf;
    --coral:     #f26540;
    --cream:     #fff9f0;
    --font-serif: 'Playfair Display', Georgia, serif;
    --font-sans:  'Space Grotesk', system-ui, sans-serif;
    --font-hand:  'Caveat', cursive;
  }
  html { 
    scroll-behavior: smooth; 
  }
  body {
    font-family: var(--font-sans);
    background: var(--canvas);
    color: var(--ink);
    overflow-x: hidden;
  }
  ::selection { 
    background: var(--gold); 
    color: #fff; 
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .nav-links {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  @media (max-width: 768px) {
    .mobile-menu-btn {
      display: block !important;
    }

    .nav-links {
      position: absolute;
      top: 84px;
      left: 4%;
      right: 4%;
      background: rgba(26,10,46,0.97);
      border: 1px solid rgba(255,255,255,0.1);
      border-radius: 20px;
      padding: 14px;
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
      display: none;
      box-shadow: 0 10px 30px rgba(0,0,0,0.25);
    }

    .nav-links.mobile-open {
      display: flex;
    }

    section {
      padding-left: 18px !important;
      padding-right: 18px !important;
    }

    h1 {
      line-height: 1.2 !important;
    }

    p {
      word-break: break-word;
    }

    button {
      width: 100%;
      max-width: 320px;
    }
  }

  /* Painterly scrollbar */
  ::-webkit-scrollbar { 
    width: 8px; 
  }
  ::-webkit-scrollbar-track { 
    background: var(--canvas); 
  }
  ::-webkit-scrollbar-thumb { 
    background: linear-gradient(var(--fuchsia), var(--lavender)); 
    border-radius: 4px; 
  }
`;
function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services/wall-murals" element={<Wallmuralchennai />} />
        <Route
          path="/services/wall-sculptures"
          element={<Wallsculptureschennai />}
        />
        <Route path="/services/large-canvas" element={<Largecanvaschennai />} />
        <Route path="/services/home-decors" element={<Homedecorschennai />} />
        <Route
          path="/services/fiberglass-grc"
          element={<Fiberglasschennai />}
        />
        <Route
          path="/services/artistic-containers"
          element={<Artisticcontainerschennai />}
        />
        <Route path="/services/facades-glass" element={<Facadeschennai />} />
        <Route path="/services/wedding-art" element={<Weddingartchennai />} />
        <Route path="/blog/wall-murals-commercial-spaces" element={<Blog1 />} />
        <Route path="/blog/school-wall-painting-ideas" element={<Blog2 />} />
        <Route
          path="/blog/custom-murals-office-interiors"
          element={<Blog3 />}
        />
        <Route path="/blog/wall-mural-cost-chennai" element={<Blog4 />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <>
      <style>{globalStyle}</style>
      <div
        style={{
          fontFamily: "var(--font-sans)",
          overflowX: "hidden",
        }}
      >
        <Header />
        <AnimatedRoutes />
        <Footer />
      </div>
    </>
  );
}
export default App;
